import { render } from "./LeeCollapse.vue?vue&type=template&id=bd105e36"
import script from "./LeeCollapse.vue?vue&type=script&lang=js"
export * from "./LeeCollapse.vue?vue&type=script&lang=js"

import exportComponent from "F:\\leeao\\leeplus_docs_code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__